export const Dollar = 'Dollar';
export const Percent = 'Percent';